<template>
  <v-layout class="pa-30 lign-center justify-center">
    <v-container class="ma-30 display-3">Not Authorized :(</v-container>
  </v-layout>
</template>




<script>
export default {
    async mounted(){
        let isAuthenticated = await this.$auth.isAuthenticatedAPI();
        if(!isAuthenticated) this.$router.push({name:"Login",query:{notification:"Not Authorized"}});
    }
    
}
</script>